<script setup>
import { onMounted, ref, inject } from 'vue';
import axios from 'axios';
import SelectionRow from './statistics/SelectionRow.vue';
import ScatterChart from './statistics/ScatterChart.vue';
import BarChart from './statistics/BarChart.vue';
import BoxPlotChart from './statistics/BoxPlotChart.vue';

const env = inject('env', {});

const filterColumns = [
    { name: 'source_name', title: 'Quelle' },
    { name: 'source_type', title: 'Cluster' },
    { name: 'category_name', title: 'Kategorie' },
];

const dimensions = ref({});
const optionsUrl = ref('');
const postUrl = ref('');

const selectionRefs = ref([]);
const selectionKeys = ref([]);
let selectionCounter = 0;

const chartData = ref([]);
const loading = ref(false);
const chartType = ref('bar');

const scatterDimensionX = ref('VI');
const scatterDimensionY = ref('AI');
const pickerDimensions = ref([]);

onMounted(() => {
    dimensions.value = JSON.parse(env.dimensionsJson || '{}');
    optionsUrl.value = env.optionsUrl || '';
    postUrl.value = env.postUrl || '';
});

function addSelection() {
    selectionKeys.value.push({
        id: selectionCounter,
        name: 'Wert-' + selectionKeys.value.length,
    });
    selectionCounter++;
}

function removeSelection(index) {
    selectionKeys.value.splice(index, 1);
}

function submitSelections() {
    if (!selectionRefs.value.length) return;

    const formValues = selectionRefs.value
        .filter(r => r)
        .map(r => r.getValues());

    const requestJSON = JSON.stringify({ selections: formValues });
    loading.value = true;

    axios.post(postUrl.value, {
        'selections-json': requestJSON,
    }).then(response => {
        chartData.value = response.data.data;
    }).catch(error => {
        console.error('Error fetching chart data:', error);
    }).finally(() => {
        loading.value = false;
    });
}
</script>

<template>
    <div>
        <h5 class="mb-3">Datensätze</h5>
        <SelectionRow v-for="(sel, index) in selectionKeys" :key="sel.id"
            :ref="el => { if (el) selectionRefs[index] = el }" :options-url="optionsUrl" :filter-columns="filterColumns"
            :initial-name="sel.name" @remove="removeSelection(index)" />

        <div class="mt-2">
            <button class="btn btn-outline-primary " @click="addSelection">Datensatz hinzufügen</button>
            <button class="btn btn-outline-primary ml-2" :disabled="loading || !selectionKeys.length"
                @click="submitSelections">
                <span v-if="loading">Laden...</span>
                <span v-else>Daten laden</span>
            </button>
        </div>
        <h5 class="mt-4">Diagramme</h5>
        <div class="btn-group mt-2" role="group">
            <button type="button" class="btn" :class="chartType === 'bar' ? 'btn-primary' : 'btn-outline-primary'"
                @click="chartType = 'bar'">Balken</button>
            <button type="button" class="btn" :class="chartType === 'boxplot' ? 'btn-primary' : 'btn-outline-primary'"
                @click="chartType = 'boxplot'">Box Plot</button>
            <button type="button" class="btn" :class="chartType === 'scatter' ? 'btn-primary' : 'btn-outline-primary'"
                @click="chartType = 'scatter'">Scatter</button>
        </div>

        <ScatterChart v-if="chartType === 'scatter'" class="mt-4" :data="chartData" :dimensions="dimensions"
            v-model:dimension-x="scatterDimensionX" v-model:dimension-y="scatterDimensionY" />
        <BarChart v-if="chartType === 'bar'" class="mt-4" :data="chartData" :dimensions="dimensions"
            v-model:selected-dimensions="pickerDimensions" />
        <BoxPlotChart v-if="chartType === 'boxplot'" class="mt-4" :data="chartData" :dimensions="dimensions"
            v-model:selected-dimensions="pickerDimensions" />
    </div>
</template>
